var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6723 64 64 49.6723 64 32C64 14.3277 49.6723 0 32 0C14.3277 0 0 14.3277 0 32C0 49.6723 14.3277 64 32 64ZM17.9446 31.2846C18.1723 31.0551 18.4429 30.8726 18.7411 30.7477C19.0393 30.6228 19.3592 30.5578 19.6825 30.5565C20.0058 30.5552 20.3262 30.6176 20.6254 30.7402C20.9246 30.8628 21.1967 31.043 21.4262 31.2708L29.5385 39.32V18.7692C29.5385 18.1164 29.7978 17.4903 30.2594 17.0287C30.7211 16.567 31.3472 16.3077 32 16.3077C32.6528 16.3077 33.2789 16.567 33.7406 17.0287C34.2022 17.4903 34.4615 18.1164 34.4615 18.7692V39.32L42.5738 31.2708C43.0378 30.8109 43.6654 30.5542 44.3186 30.5571C44.9718 30.56 45.5971 30.8222 46.0569 31.2862C46.5168 31.7501 46.7735 32.3777 46.7706 33.0309C46.7677 33.6841 46.5055 34.3094 46.0415 34.7692L33.7338 46.9831C33.2728 47.4406 32.6496 47.6973 32 47.6973C31.3504 47.6973 30.7272 47.4406 30.2662 46.9831L17.9585 34.7692C17.7285 34.5415 17.5456 34.2707 17.4204 33.9722C17.2952 33.6737 17.2301 33.3535 17.2288 33.0298C17.2275 32.7061 17.2901 32.3854 17.4129 32.0859C17.5357 31.7865 17.7164 31.5142 17.9446 31.2846Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/DownloadIcon.15005cc07b3dbcd3d27d8fa194c44d2f.svg";
export { ForwardRef as ReactComponent };